export default {
    en: {
        tab: {
            conference: 'Academic Activity',
            funding: 'Research Fund',
            patent: 'Intellectual Property Rights',
            techtrans: 'Tech Transfer',
            report: 'Research Report',
        },
        list: {
            conference:{
                researchRole: 'Classification of Academic Activity',
                cfrcNm: 'Title of Academic Conference',
                orgLangPprNm: 'Title of Article Presented',
                issueDt: 'Date of Presentation',
            },
            funding:{
                subjNo:'Project No.',
                subjNm:'Project Name',
                subjFdt:'Starting Date of Research',
                totRsrcct:'Total Fund',
            },
            patent:{
                itlPprRgtDiv:'Classification',
                itlPprRgtNm:'Title of IP Right',
                applRegDt:'Application Date',
                regDt:'Registration Date',
            },
            techtrans:{
                techtransferDiv:'Classification',
                techtransferNm:'Title of Tech Transferred',
                contractDt:'Date of Contract',
                paymentDt:'Date of Payment',
            },
            report:{
                reportNm:'Title of Research Report',
                issueOrg:'Institution',
                issueDt:'Date of Publication',
            },
        },
        detail:{
            roleCd: 'Mode of Participation and Role',
            domInter:'Domestic/International',
            domestic:'Domestic', // 코드 존재
            foreign:'Foreign', // 코드 존재

            conference:{
                cfrcHctrCd:'Country',
                researchRole:'Role',
                orgLangPprNm:'Title of Article Presented',
                cfrcNm:'Title of Academic Conference',
                hldAgcNm:'Host Institution',
                cfrcPeriod:'Period',
                issueDt:'Date of Presentation',
                countryNm:'Country Name',
                countrySum:'Number of participated countries',

            },
            funding:{
                subjNo:'Project No.',
                subjNm:'Project Name',
                bizNm:'Project Management Agency',
                totRsrcct:'Total Fund',
                suppSnm:'Funding Agency',
                subjFdt:'Starting date',
                subjTdt:'Expiry date',
                professor: 'Leading faculty',
                researcher: 'Research Faculty and Full-Time Researcher',
                helper: 'Ph.D. Candidate and Research Member',
                inCampus: 'In-Campus',
            },
            patent:{
                itlPprRgtDiv: 'Category',
                itlPprRgtNm: 'Title of Intellectual Property Rights',
                applRegDt: 'Application Date',
                applRegNo: 'Application No.',
                regDt: 'Registration Date',
                regNo:'Registration No.',
            },
            techtrans:{
                techtransferDiv: 'Category',
                director: 'Leading Faculty',
                techtransferNm: 'Title of Tech Transfer',
                companyNm: 'Name of Industry',
                companyDiv: 'Category of Industry',
                regions: 'Regions',
                techtransferKind: 'Form of Transfer',
                techType:'Field of Transfer',            //의심할 필요 있음
                contractPeriod: 'Contract Period',
                contractDt: 'Date of Contract',
                paymentDt: 'Deposit Date',
                schoolFund: 'Yonsei Deposit',
            },
            report:{
                reportNm:'Title',
                issueDt:'Date of Publication',
                issueOrg:'Institution',
            },
        },
        help:{
            conference:{
                title:'Notes for academic activities',
                line2:{
                    1:'Academic Activities entered in YRI and approved by YRI are transferred to the TAMS.',
                    2:"- Inquiry about YRI: yri{'@'}yonsei.ac.kr (Phone +82-2-2123-6436)",
                },
                line3: 'SCOPUS-document type: conference paper achievements: Achievements entered/approved as papers at YRI, such as excellent academic conferences in the CS field, are linked to TAMS Article menu, or for general academic activities, achievements must be entered as academic activities in YRI to be linked to TAMS Academic Activity menu.'
            },
            funding:{
                title:'Notes for research funds',
                line2:{
                    1:'Research funds entered in RMS (https://rms2.yonsei.ac.kr) and approved by YRI are transferred to the TAMS.',
                    2:'- Inquiry about RMS: person in charge of each funds of Univ. industry foundation'
                },
                line3: 'External research funds contracted under the name of President of University-Industry Foundation are subjected to evaluate.',
                line4: 'Points of research funds depend on the starting date and total amount of fund.'
            },
            patent:{
                title:'Notes',
                line2: 'In case of changing status of intellectual property rights (e.g. patent application → registration), please re-confirm the each achievement and \'Save\' again before print out the Performance Report.',
                line3:{
                    1:'Intellectual property rights and Tech transfer entered in YSIS(https://ysis2.yonsei.ac.kr) and approved by YRI are transferred to the TAMS.',
                    2:"- Inquiry about YSIS: dahhye{'@'}yonsei.ac.kr (Sinchon/international campus)"
                }
            },
            line1: 'Points will be calculated when clicking each achievement and confirm (\'Save\') the number of authors and mode of participation&role. If the points are 0 or if you select “Not Applicable” of the each achievement, the Performance Report does not show the achievement.',
        },
    },
    ko: {
        tab: {
            conference: '학술활동',
            funding: '연구비',
            patent: '지적재산권',
            techtrans: '기술이전',
            report: '연구보고서',
        },
        list: {
            conference: {
                researchRole: '학술활동구분',
                cfrcNm: '학술회의 명칭',
                orgLangPprNm: '발표논문제목',
                issueDt: '발표일자',
            },
            funding: {
                subjNo: '과제번호',
                subjNm: '연구과제명',
                subjFdt: '연구게시년월',
                totRsrcct: '총연구비'
            },
            patent: {
                itlPprRgtDiv: '구분',
                itlPprRgtNm: '지식재산권명',
                applRegDt: '출원일자',
                regDt: '등록일자',
            },
            techtrans: {
                techtransferDiv: '구분',
                techtransferNm: '기술이전명',
                contractDt: '계약일자',
                paymentDt: '기술료입금일',
            },
            report: {
                reportNm: '보고서 제목',
                issueOrg: '지원기관',
                issueDt: '발행일자'
            },
        },
        detail:{
            roleCd: '참여형태 및 역할',
            domInter:'국제/국내',
            domestic:'국내', // 코드 존재
            foreign:'국제', // 코드 존재

            conference:{
                cfrcHctrCd:'개최국가',
                researchRole:'연구역할',
                orgLangPprNm:'발표논문 제목',
                cfrcNm:'학술회의 명칭',
                hldAgcNm:'주최기관',
                cfrcPeriod:'개최기간',
                issueDt:'발표일자',
                countryNm:'참여국가명',
                countrySum:'참여국가수',
            },
            funding:{
                subjNo:'과제번호',
                subjNm:'연구과제명',
                bizNm:'사업기관/사업명',
                totRsrcct:'연구비 총합계',
                suppSnm:'연구비 지원기관',
                subjFdt:'시작일',
                subjTdt:'종료일',
                professor: '연구책임자',
                researcher: '공동연구원수',
                helper: '연구보조원수',
                inCampus: '연구원수',
            },
            patent:{
                itlPprRgtDiv: '구분',
                itlPprRgtNm: '지식재산권명',
                applRegDt: '출원일자',
                applRegNo: '출원번호',
                regDt: '등록일자',
                regNo:'등록번호',
            },
            techtrans:{
                techtransferDiv: '기술이전 구분',
                director: '기술이전 책임자',
                techtransferNm: '기술이전명',
                companyNm: '산업체명',
                companyDiv: '산업체 구분',
                regions: '지역',
                techtransferKind: '기술이전 형태',
                techType:'기술분야',            //의심할 필요 있음
                contractPeriod: '계약기간',
                contractDt: '계약일자',
                paymentDt: '기술료입금일',
                schoolFund: '학교 적립금',
            },
            report:{
                reportNm:'제목',
                issueDt:'발행일자',
                issueOrg:'지원기관',
            }
        },
        help:{
            conference:{
                title:'학술활동 입력 안내',
                line2:{
                    1:'학술활동은 YRI에 입력/승인된 업적이 이 시스템(TAMS)에 반영됩니다.',
                    2:"- YRI 관련 문의  yri{'@'}yonsei.ac.kr (내선 6436)",
                },
                line3: 'SCOPUS - document type: conference paper 업적: CS분야 우수학술대회 논문 등 YRI에서 논문으로 입력/승인된 업적은 TAMS에도 논문 메뉴로 연동되며, 그 외 일반적인 학술활동의 경우, YRI에서도 학술활동으로 입력하셔야 TAMS에서도 학술활동 메뉴로 연동됩니다.'
            },
            funding:{
                title:'연구비 입력 안내',
                line2:{
                    1:'연구비는 RMS(https://rms2.yonsei.ac.kr)에서 입력된 업적이 YRI에 연계되어 이 시스템(TAMS)에 반영됩니다.',
                    2:'관련 문의: 해당 과제 담당자(산학협력단)에게 문의'
                },
                line3: '외부기관의 연구비 수혜로서, 연세대학교 산학협력단장 명의로 계약된 경우 연구평점을 부여받을 수 있습니다.',
                line4: '연구비 수혜 평점은 연구게시년월을 기준으로 총연구비에 대한 평가점수가 반영됩니다(연도별 평가 아님).'
            },
            patent:{
                title:'지적재산권 및 기술이전 입력 안내',
                line2: '지적재산권(특허 출원/특허 등록)을 확인 · 저장했다가 추후 변경사항이 발생할 경우(예 : 특허 출원 -> 특허 등록), 반드시 다시 확인 · 저장하셔야 업적보고서에 해당 내용이 표시됩니다.',
                line3:{
                    1:'지적재산권(특허) 및 기술이전은 YSIS(https://ysis2.yonsei.ac.kr)에서 입력한 업적이 YRI에 연계되어 이 시스템(TAMS)에 반영됩니다.',
                    2:"- YSIS 관련 문의: 신촌캠퍼스 dahhye{'@'}yonsei.ac.kr"
                }
            },
            line1: '업적점수는 반드시 해당 업적을 클릭하여 내용을 확인하고 "참여형태 및 역할" 구분을 선택 후 저장버튼을 눌러야 점수가 반영됩니다.',
        },
    },
}